var t=function(){return window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth};export{t as default};
//# sourceMappingURL=windowWidth.mjs.map
